import {
    INSERT_CACHE_ITEM,
    DELETE_CACHE_ITEM
} from '../../../core/js/actions/cacheActions';

export function cacheReducer(state = {}, action) {
    switch (action.type) {
        case INSERT_CACHE_ITEM:
            return Object.assign(
               {}, state, {
                   [action.payload.key]: action.payload.item
               }
            );
        case DELETE_CACHE_ITEM:
            return _.omit(state, action.payload.key);
        default:
            return state;
    }
}
